<ng-container *ngIf="isEpcot; else nonEpcotTemplate">
    <bs-digital-linear-result-combo
        [succeededSlip]="succeededSlip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [inColumn]="inColumn"
        [moduleName]="title"
        [betslipType]="systemType" />
</ng-container>

<ng-template #nonEpcotTemplate>
    <bs-digital-linear-result-system
        [succeededSlip]="succeededSlip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [inColumn]="inColumn"
        [moduleName]="title ?? ''" />
</ng-template>
